(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WebRecorder", [], factory);
	else if(typeof exports === 'object')
		exports["WebRecorder"] = factory();
	else
		root["WebRecorder"] = factory();
})(window, function() {
return 